import { defineContent, type DefinedContent } from '@post-office/define-content';

export const registeredContent: DefinedContent<
	['title', 'description', 'buttonName', 'dismissLabel']
> = defineContent({
	default: {
		title: {
			id: 'jira-crossflow-recommendation-jsm-operations.banner-title',
			defaultMessage: 'Supercharge your IT teams with operations',
			description: 'Title for the JSM Operations crossflow recommendation banner',
			role: 'title',
		},
		description: {
			id: 'jira-crossflow-recommendation-jsm-operations.banner-description',
			defaultMessage:
				'Create on-call schedules and track alerts to resolve incidents faster. <link>Read more about operations</link>',
			description:
				'Description for the JSM Operations crossflow recommendation banner. Contains an inline <link> chunk linking to the operations docs.',
			role: 'description',
		},
		buttonName: {
			id: 'jira-crossflow-recommendation-jsm-operations.banner-button',
			defaultMessage: "Let's start",
			description:
				'CTA button text for the JSM Operations crossflow recommendation banner. Opens the team enablement modal where the user can create or enable teams.',
		},
		dismissLabel: {
			id: 'jira-crossflow-recommendation-jsm-operations.banner-dismiss',
			defaultMessage: 'Dismiss',
			description: 'Dismiss button label for the JSM Operations crossflow recommendation banner',
		},
	},
});
